import { useState } from "react";

export const IsMobi = () => {
  const [isMobile, setIsMobile] = useState(window.screen.availWidth < 600);
  window.addEventListener("resize", () => {
    setIsMobile(window.screen.availWidth < 600);
  });
  return isMobile;
};
